"use client";

import * as PopoverPrimitive from "@radix-ui/react-popover";
import type * as React from "react";

import { cn } from "../lib/utils";

const Popover: React.FC<PopoverPrimitive.PopoverProps> = PopoverPrimitive.Root;

const PopoverTrigger: React.ForwardRefExoticComponent<
	PopoverPrimitive.PopoverTriggerProps & React.RefAttributes<HTMLButtonElement>
> = PopoverPrimitive.Trigger;

const PopoverContent: React.ForwardRefExoticComponent<
	Omit<
		PopoverPrimitive.PopoverContentProps & React.RefAttributes<HTMLDivElement>,
		"ref"
	> &
		React.RefAttributes<HTMLDivElement>
> = ({
	ref,
	className,
	align = "center",
	sideOffset = 4,
	children,
	...props
}: React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
	ref?: React.RefObject<React.ElementRef<typeof PopoverPrimitive.Content>>;
}) => (
	<PopoverPrimitive.Portal>
		<PopoverPrimitive.Content
			ref={ref}
			align={align}
			sideOffset={sideOffset}
			className={cn(
				"z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-hidden animate-in data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
				className,
			)}
			children={children}
			{...props}
		/>
	</PopoverPrimitive.Portal>
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent };
